<template>
    <div
        class="logo-wrap"
        :style="{
            width: isCollapse ? '64px' : '200px',
            height: isCollapse ? '40px' : '40px',
        }"
    >
        <!-- <img class="logo-img"
         src="../../assets/image/header/logo.png"
         alt="logo"
         @click="handleChangeCollapse"
        /> -->
        <i class="iconfont icon-tuodong" @click="handleChangeCollapse"></i>
        <!-- <span class="title" v-if="!this.isCollapse">Loratech OA</span>
        <span class="version" v-if="!this.isCollapse">1.0</span> -->
        <template v-if="!this.isCollapse">
            <span class="title">Milewsys OA</span>
            <span class="version">1.0</span>
        </template>
    </div>
</template>
<script>
export default {
    computed: {
        isCollapse() {
            return this.$store.state.index.isCollapse;
        },
    },
    methods: {
        /**
         * 收起还是展开
         */
        handleChangeCollapse() {
            this.$store.commit("INDEX_COLLAPSE", !this.isCollapse);
        },
    },
};
</script>
<style lang="scss">
.logo-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: inline-flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    color: #fff;
    font-weight: bolder;
    font-size: 18px;
    transition: width 100ms;
    background: $theme-color;
    z-index: 1;
    overflow: hidden;
    padding: 6px 0;
    i.iconfont {
        font-size: 18px;
        cursor: pointer;
    }
    .logo-img {
        width: 30px;
        height: 28px;
        margin: 0 8px;
    }
    .title {
        // margin: 4px 0 0 10px;
        font-size: 14px;
        line-height: 32px;
    }
    .version {
        color: inherit;
        // position: absolute;
        margin-right: 10px;
        font-size: 12px;
        line-height: 2;
    }
}
</style>
